import React, { useContext } from "react";
import { Box, useTheme, Button, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import TokenContext from "../context/TokenContext";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TablaProyectos from "./tablas/TablaProyectos";
import { actualizarInvestigacion, crearDesarrollos, crearPresentacionAcongresos, crearProyecto, crearPublicacionRevista, crearTituloPropiedad, desarrollos, presentaciones, proyectosInvestigacion, revistas, titulos } from "../Redux/investigacion";
import { COLUMNSDESARROLLOS, COLUMNSPRESENTACION, COLUMNSPROYECTOS, COLUMNSREVISTAS, COLUMNSTITULOS } from "../columnas/columnasInvestigacion";
import ModalProyectos from "./modales/ModalProyectos";
import TablaProductos from "./tablas/TablaProductos";
import ModalRevistas from "./modales/ModalRevistas";
import ModalPresentacion from "./modales/ModalPresentacion";
import ModalTituloPropiedad from "./modales/ModalTituloPropiedad";
import ModalDesarrollosNoPasibles from "./modales/ModalDesarrollosNoPasibles";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { miLegajo } from "../Redux/legajo";

const Investigacion = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();
    const [valuePrimerTab, setValuePrimerTab] = React.useState('1'); //value del tablist
    const [selectedValue, setSelectedValue] = React.useState(''); //conicet
    const [selectedValue2, setSelectedValue2] = React.useState(''); //programa de incentivos

    const legajoSelector = useSelector(store => store.legajo.legajo)

    const [proyectos, setProyectos] = React.useState([])
    const proyectosSelector = useSelector(store => store.investigacion.proyectosInvestigacion)

    const [revista, setRevista] = React.useState([])
    const revistasSelector = useSelector(store => store.investigacion.revistas)

    const [presentacion, setPresentacion] = React.useState([])
    const presentacionesSelector = useSelector(store => store.investigacion.presentaciones)

    const [titulo, setTitulo] = React.useState([])
    const titulosSelector = useSelector(store => store.investigacion.titulos)

    const [desarrollo, setDesarrollo] = React.useState([])
    const desarrollosSelector = useSelector(store => store.investigacion.desarrollos)

    const [openModal1, setOpenModal1] = React.useState(false)
    const handleOpen1 = () => setOpenModal1(true);
    const handleClose1 = () => setOpenModal1(false);

    const [openModal2, setOpenModal2] = React.useState(false)
    const handleOpen2 = () => setOpenModal2(true);
    const handleClose2 = () => setOpenModal2(false);

    const [openModal3, setOpenModal3] = React.useState(false)
    const handleOpen3 = () => setOpenModal3(true);
    const handleClose3 = () => setOpenModal3(false);

    const [openModal4, setOpenModal4] = React.useState(false)
    const handleOpen4 = () => setOpenModal4(true);
    const handleClose4 = () => setOpenModal4(false);

    const [openModal5, setOpenModal5] = React.useState(false)
    const handleOpen5 = () => setOpenModal5(true);
    const handleClose5 = () => setOpenModal5(false);

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(miLegajo(token, empleado.empleadoid))
            dispatch(proyectosInvestigacion(token, empleado.usuarioPortalRh))
            dispatch(revistas(token, empleado.usuarioPortalRh))
            dispatch(presentaciones(token, empleado.usuarioPortalRh))
            dispatch(titulos(token, empleado.usuarioPortalRh))
            dispatch(desarrollos(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (legajoSelector.length > 0) {
            const item = {
                value: legajoSelector[0].new_conicet,
                label: legajoSelector[0]["new_conicet@OData.Community.Display.V1.FormattedValue"]
            };
            const item2 = {
                value: legajoSelector[0].new_programade,
                label: legajoSelector[0]["new_programade@OData.Community.Display.V1.FormattedValue"]
            };
            setSelectedValue(item.value);
            setSelectedValue2(item2.value)
        }
    }, [legajoSelector])

    React.useEffect(() => {
        if (proyectosSelector?.length > 0) {
            var array = []
            proyectosSelector.forEach(element => {
                var objeto = {
                    id: element.new_proyectosdeinvestigacinid,
                    new_carcterdelaparticipcin: element["new_carcterdelaparticipcin@OData.Community.Display.V1.FormattedValue"],
                    new_fechadefinalizacin: element["new_fechadefinalizacin@OData.Community.Display.V1.FormattedValue"],
                    new_fechadeinicio: element["new_fechadeinicio@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    _new_institucion_value: element["_new_institucion_value@OData.Community.Display.V1.FormattedValue"],
                    _new_institucionevaluadora_value: element["_new_institucionevaluadora_value@OData.Community.Display.V1.FormattedValue"],
                    _new_institucionfinanciadora_value: element["_new_institucionfinanciadora_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setProyectos(array)
        }
    }, [proyectosSelector])

    React.useEffect(() => {
        if (revistasSelector?.length > 0) {
            var array = []
            revistasSelector.forEach(element => {
                var objeto = {
                    id: element.new_publicacionenrevistaid,
                    new_autores: element.new_autores,
                    new_revista: element.new_revista,
                    new_volumen: element.new_volumen,
                    new_paginas: element.new_paginas,
                    new_name: element.new_name,
                    new_fechadepublicacin: element["new_fechadepublicacin@OData.Community.Display.V1.FormattedValue"],
                    new_conarbitraje: element["new_conarbitraje@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setRevista(array)
        }
    }, [revistasSelector])

    React.useEffect(() => {
        if (presentacionesSelector?.length > 0) {
            var array = []
            presentacionesSelector.forEach(element => {
                var objeto = {
                    id: element.new_presentacinacongresosseminariosid,
                    new_autores: element.new_autores,
                    new_evento: element.new_evento,
                    new_fechaderealizacin: element["new_fechaderealizacin@OData.Community.Display.V1.FormattedValue"],
                    new_lugarderealizacin: element.new_lugarderealizacin,
                    new_name: element.new_name,
                }
                array.push(objeto)
            });
            setPresentacion(array)
        }
    }, [presentacionesSelector])

    React.useEffect(() => {
        if (titulosSelector?.length > 0) {
            var array = []
            titulosSelector.forEach(element => {
                var objeto = {
                    id: element.new_ttulodepropiedadintelectualid,
                    new_fechaotorgamiento: element["new_fechaotorgamiento@OData.Community.Display.V1.FormattedValue"],
                    new_fechasolicitud: element["new_fechasolicitud@OData.Community.Display.V1.FormattedValue"],
                    new_titular: element.new_titular,
                    new_name: element.new_name,
                }
                array.push(objeto)
            });
            setTitulo(array)
        }
    }, [titulosSelector])

    React.useEffect(() => {
        if (desarrollosSelector?.length > 0) {
            var array = []
            desarrollosSelector.forEach(element => {
                var objeto = {
                    id: element.new_desarrollonopasiblepropiedadintelectualid,
                    new_descripcion: element.new_descripcion,
                    new_name: element.new_name,
                }
                array.push(objeto)
            });
            setDesarrollo(array)
        }
    }, [desarrollosSelector])

    const handleChangePrimerTAB = (event, newValue) => {
        setValuePrimerTab(newValue);
    };

    const handleSubmitProyectos = (datos) => {
        dispatch(crearProyecto(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose1()
                dispatch(proyectosInvestigacion(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const handleSubmitRevistas = (datos) => {
        dispatch(crearPublicacionRevista(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose2()
                dispatch(revistas(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const handleSubmitPresentaciones = (datos) => {
        dispatch(crearPresentacionAcongresos(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose3()
                dispatch(presentaciones(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const handleSubmitTitulo = (datos) => {
        dispatch(crearTituloPropiedad(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose4()
                dispatch(titulos(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const handleSubmitDesarrollos = (datos) => {
        dispatch(crearDesarrollos(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose5()
                dispatch(desarrollos(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const handleUpdateSelects = () => {
        dispatch(actualizarInvestigacion(empleado.empleadoid, selectedValue, selectedValue2, token))
            .then((id) => {
                dispatch(miLegajo(token, empleado.empleadoid))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const options = [
        { value: true, label: 'Si' },
        { value: false, label: 'No' }
    ]

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Investigación"}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TabContext value={valuePrimerTab}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <TabList
                                    aria-label="scrollable force tabs example"
                                    onChange={handleChangePrimerTAB} variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    textColor="secondary"
                                    indicatorColor="secondary"
                                >
                                    <Tab label="Antecedentes en Investigación Científico-Tecnológico" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Pincipales Productos" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Resultados de Trabajos" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                </TabList>
                            </Box>
                            <TabPanel value="1">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={5} sx={{ mb: 2 }}>
                                        <FormControl fullWidth>
                                            <InputLabel id="select-label">CONICET</InputLabel>
                                            <Select
                                                color="secondary"
                                                labelId="select-label"
                                                value={selectedValue}
                                                onChange={event => setSelectedValue(event.target.value)}
                                            >
                                                {options.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} sm={5} sx={{ mb: 2 }}>
                                        <FormControl fullWidth>
                                            <InputLabel id="select-label">Programa de Incentivos</InputLabel>
                                            <Select
                                                color="secondary"
                                                labelId="select-label"
                                                value={selectedValue2}
                                                onChange={event => setSelectedValue2(event.target.value)}
                                            >
                                                {options.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={2} sx={{ mb: 2 }}>
                                        <Button onClick={handleUpdateSelects} color="secondary" variant="contained">Actualizar valores</Button>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <TablaProyectos
                                            columnas={COLUMNSPROYECTOS}
                                            lineas={proyectos}
                                            handleOpen={handleOpen1}
                                        />
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value="2">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                Publicaciones en Revistas
                                            </Typography>
                                        </Box>
                                        <TablaProductos
                                            columnas={COLUMNSREVISTAS}
                                            lineas={revista}
                                            handleOpen={handleOpen2}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                Presentación a Congresos/Seminarios
                                            </Typography>
                                        </Box>
                                        <TablaProductos
                                            columnas={COLUMNSPRESENTACION}
                                            lineas={presentacion}
                                            handleOpen={handleOpen3}
                                        />
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value="3">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                Títulos de propiedad intelectual
                                            </Typography>
                                        </Box>
                                        <TablaProductos
                                            columnas={COLUMNSTITULOS}
                                            lineas={titulo}
                                            handleOpen={handleOpen4}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                Desarrollos no pasibles propiedad intelectual
                                            </Typography>
                                        </Box>
                                        <TablaProductos
                                            columnas={COLUMNSDESARROLLOS}
                                            lineas={desarrollo}
                                            handleOpen={handleOpen5}
                                        />
                                    </Grid>
                                </Grid>
                            </TabPanel>
                        </TabContext>

                    </Grid>
                </Grid>
            </Box>
            <ModalProyectos open={openModal1} handleClose={handleClose1} onSubmit={handleSubmitProyectos} />
            <ModalRevistas open={openModal2} handleClose={handleClose2} onSubmit={handleSubmitRevistas} />
            <ModalPresentacion open={openModal3} handleClose={handleClose3} onSubmit={handleSubmitPresentaciones} />
            <ModalTituloPropiedad open={openModal4} handleClose={handleClose4} onSubmit={handleSubmitTitulo} />
            <ModalDesarrollosNoPasibles open={openModal5} handleClose={handleClose5} onSubmit={handleSubmitDesarrollos} />
        </motion.div>
    )
}

export default Investigacion